import React, { FC } from 'react';
import styles from './styles.module.css';
import { Asset } from '@clearcover/atlas';
import {
  AddPaymentMethodPayloadType,
  PaymentCardType,
} from '@clearcover/core-app-types';
import { paymentIcon } from 'Shared/constants/paymentIcon';
import { useFormikContext } from 'formik';
import classnames from 'classnames';

type IconsListType = {
  iconType: 'all' | 'bank' | 'creditCard';
};

export const IconsList: FC<IconsListType> = ({ iconType }) => {
  const { values } =
    useFormikContext<AddPaymentMethodPayloadType['paymentMethod']>();
  const creditCardTypes = (
    Object.keys(paymentIcon) as Array<PaymentCardType>
  ).splice(0, Object.keys(paymentIcon).length - 2);
  const creditCardSelected = values.type === 'ENCRYPTED_CREDIT_CARD';

  switch (iconType) {
    case 'creditCard':
      return (
        <div className={styles.creditCardIconList}>
          {creditCardTypes.map((cardType, index) => {
            return (
              <div key={index}>
                <Asset
                  icon={paymentIcon[cardType]}
                  className={classnames(styles[cardType], {
                    [styles.isSelected]: creditCardSelected,
                  })}
                  description="credit card"
                  height={30}
                  width={30}
                />
              </div>
            );
          })}
        </div>
      );
    case 'bank':
      return (
        <div>
          <Asset
            icon={paymentIcon['bank']}
            className={classnames(styles.bank, {
              [styles.isSelected]: !creditCardSelected,
            })}
            description="bank"
            height={20}
            width={20}
          />
        </div>
      );
    default:
      return (
        <>
          {(Object.keys(paymentIcon) as Array<PaymentCardType | 'bank'>).map(
            (icon, index) => {
              return (
                <div key={index}>
                  <Asset
                    icon={paymentIcon[icon]}
                    className={styles[icon]}
                    description="credit card"
                    height={30}
                    width={30}
                  />
                </div>
              );
            }
          )}
        </>
      );
  }
};
